var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import { SelectedTicket } from "models/selected.model";
import { specialTicketTypes } from "utils/consts";
import { Discount } from "utils/mongo/discounts.model";
import { get, post } from "./api";
const delayFor = (seconds) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
});
export const validateDiscountCode = (discountId, selectedTicket, setSelectedTicket, tickets) => __awaiter(void 0, void 0, void 0, function* () {
    if (!selectedTicket)
        return false;
    if (!discountId) {
        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), { discount: undefined })));
        return false;
    }
    const { err, res: data } = yield to(get(`/discounts/${discountId}`));
    //await delayFor(1);
    if (err || !data) {
        console.log("Error validating discount code", err);
        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), { discount: undefined })));
        return false;
    }
    const selectedTicketType = selectedTicket.ticket.id;
    const ticketTypes = specialTicketTypes.includes(selectedTicketType)
        ? specialTicketTypes
        : [selectedTicketType];
    console.log("get validateDiscountCode:::", data);
    const discount = new Discount(data);
    const isValid = ticketTypes.includes(discount.ticketId) &&
        (discount.remainingUses > 0 || discount.reusable);
    if (isValid) {
        const ticket = tickets.find((t) => t.id === discount.ticketId) || selectedTicket.ticket;
        let quantity = selectedTicket.quantity;
        if (!discount.reusable) {
            if (!specialTicketTypes.includes(discount.ticketId)) {
                quantity = discount.remainingUses;
            }
        }
        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), { quantity, discount, ticket })));
    }
    else {
        setSelectedTicket(new SelectedTicket(Object.assign(Object.assign({}, selectedTicket), { discount })));
    }
    //console.log("isValid", isValid);
    return isValid;
});
export const markDiscount = (discountId, quantity) => __awaiter(void 0, void 0, void 0, function* () {
    const { err, res: data } = yield to(post(`/discounts/mark/${discountId}`, {
        quantity,
    }));
    if (err || !data)
        return false;
    return true;
});
